import { IconButton, Paper, Stack, Typography } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { useState } from "react";
import DocumentItems from "./DocumentItem";
import AddDocumentModal from "./AddDocumentModal";
import { useDocuments } from "../../../../view-booking/hooks/UseDocuments";
import { DocumentItem } from "../../../types/documents";

interface DocumentsSectionProps {
  documents: DocumentItem[];
  bookingId: string;
  onAddDocument: (doc: DocumentItem) => void;
}

export default function DocumentsSection({
  documents,
  bookingId,
  onAddDocument,
}: DocumentsSectionProps) {
  const [open, setOpen] = useState(false);
  const { documentLoading, handleSaveDocument } = useDocuments();

  const categories = [
    "Invoice",
    "Quotation",
    "Internet Agreement Form",
    "Service Delivery",
    "Stream Report",
    "Program",
    "Other",
    "Blank one",
    "Blank two",
  ];

  return (
    <Paper
      sx={{ flex: 1, borderRadius: "12px", p: 2, boxShadow: 0, height: "100%" }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "black" }}>
          Documents
        </Typography>

        <IconButton size="small" onClick={() => setOpen(true)}>
          <Add sx={{ fontSize: 22 }} />
        </IconButton>
      </Stack>

      <Stack spacing={1}>
        {documents.map((doc) => (
          <DocumentItems key={doc.id} document={doc} />
        ))}
      </Stack>

      <AddDocumentModal
        open={open}
        onClose={() => setOpen(false)}
        loading={documentLoading}
        categories={categories}
        onSave={async ({ name, description, category, file }) => {
          const saved = await handleSaveDocument(
            bookingId,
            name,
            category,
            description,
            file,
          );

          if (saved) {
            onAddDocument(saved);
          }
        }}
      />
    </Paper>
  );
}
